<template>
  <div class="news-feed container-fluid">
    <div v-if="name" class="padding-top-1 padding-bottom-0">
      <h3 v-if="news.items.length === 0 && news.endReached" class="no-news text-center text-thin text-muted margin-top-2">Ingen nyheder om {{name}}</h3>
      <div v-else class="padding-bottom-1 news-feed-header">
        <h2 class="text-center margin-top-bottom-2">Nyheder om {{name}}</h2>
      </div>
    </div>
    <template v-for="newsLayout in newsLayouts">
      <template v-if="newsLayout.layoutName === 'full-width'">
        <div class="row" :key="newsLayout.items[0].id">
          <div class="col-12 padding-left-right-0 news-feed-item-wrapper">
            <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated"></news-feed-item>
          </div>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '2-equal'">
        <div class="row" :key="newsLayout.items[0].id">
          <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="col-12 col-md-6 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-left-min-sm" max-width="xs"></news-feed-item>
          <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="col-12 col-md-6 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-right-min-sm" max-width="xs"></news-feed-item>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '3-fourths-1-fourth'">
        <div class="row" :key="newsLayout.items[0].id">
          <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="col-12 col-md-7 col-lg-9 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-left-min-sm" max-width="sm"></news-feed-item>
          <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="col-12 col-md-5 col-lg-3 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-right-min-sm" max-width="xs"></news-feed-item>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '3-equal'">
        <div class="row" :key="newsLayout.items[0].id">
          <news-feed-item v-for="(item, i) in newsLayout.items" :key="item.id" :is-related-news="feedType === 'entity-related'" :feed-item="item" :query-related="isQueryRelated" class="col-12 col-md-4 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper" :class="{'no-padding-right-min-sm': i == 2, 'no-padding-left-min-sm': i == 0}" max-width="sm"></news-feed-item>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '2-thirds-1-third'">
        <div class="row" :key="newsLayout.items[0].id">
          <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="col-12 col-md-8 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-left-min-sm" max-width="xs"></news-feed-item>
          <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="col-12 col-md-4 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-right-min-sm" max-width="xs"></news-feed-item>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '1-third-2-thirds'">
        <div class="row" :key="newsLayout.items[0].id">
          <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="col-12 col-md-4 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-left-min-sm" max-width="xs"></news-feed-item>
          <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="col-12 col-md-8 no-side-padding-xxs no-side-padding-xs news-feed-item-wrapper no-padding-right-min-sm" max-width="xs"></news-feed-item>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === 'equal-2-rows-1-row'">
        <div class="row match-shortest-column-grid" :key="newsLayout.items[0].id">
          <div>
            <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="xs"></news-feed-item>
            <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="xs"></news-feed-item>
          </div>
          <div class="featured-person">
            <news-feed-item v-if="newsLayout.items[2]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[2]" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="xs"></news-feed-item>
          </div>
        </div>
      </template>
      <template v-else-if="newsLayout.layoutName === '2-columns-3-fourths-1-fourth'">
        <div class="row" :key="newsLayout.items[0].id">
          <div class="col-12 col-md-7 col-lg-9 no-side-padding-xxs no-side-padding-xs no-padding-left-min-sm">
            <news-feed-item :feed-item="newsLayout.items[0]" :is-related-news="feedType === 'entity-related'" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="sm"></news-feed-item>
            <news-feed-item v-if="newsLayout.items[1]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[1]" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="sm"></news-feed-item>
          </div>
          <div class="col-12 col-md-5 col-lg-3 no-side-padding-xxs no-side-padding-xs no-padding-right-min-sm">
            <news-feed-item v-if="newsLayout.items[2]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[2]" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="xs"></news-feed-item>
            <news-feed-item v-if="newsLayout.items[3]" :is-related-news="feedType === 'entity-related'" :feed-item="newsLayout.items[3]" :query-related="isQueryRelated" class="news-feed-item-wrapper" max-width="xs"></news-feed-item>
          </div>
        </div>
      </template>
    </template>
    <div class="row" v-if="!hideFooter">
      <news-load-footer v-if="news.items" :news="news" :loading="loading" :feedType="feedType"></news-load-footer>
    </div>
  </div>
</template>

<script>
import NewsFeedItem from '@/components/NewsFeedItem'
import NewsPreview from '@/components/NewsPreview'
import NewsLoadFooter from '@/components/NewsLoadFooter'
import userStore from '@/modules/users/store'
import windowSize from '@/window-size'
export default {
  name: 'newsFeed',
  props: {
    news: {
      type: Object,
      required: true
    },
    'feed-type': {
      type: String,
      required: true
    },
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      required: true
    },
    'hide-footer': {
      type: Boolean
    },
    isQueryRelated: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
    }
  },
  created() {
    // Only images at the top of the page that are immediately visible should load immediately for SEO/Performance
    this.items.slice(2).forEach(i => i.deferLoad = true)
  },
  computed: {
    isLoggedIn () {
      return !!userStore.user
    },
    items: function () {
      return this.news.items
    },
    isMobile () {
      return windowSize.width < windowSize.sizes.sm
    },
    newsLayouts: function () {
      switch (this.feedType) {
        case 'entity-related':
          if (this.isLoggedIn) {
            return this.chunkBy(this.items, 2).map((c) => {
              return {
                layoutName: '2-equal',
                items: c.map((i) => ({
                  type: 'news-preview',
                  item: { previewType: 'basic', item: i },
                  id: i.uniqueId
                }))
              }
            })
          } else {
            let items = this.items.slice(0)
            const columnAmount = this.isMobile ? 1 : 2
            const isPersonPage = this.$route.matched.some(({ name }) => name === 'person')
            // For the current prospecting ad, advertising only makes sense on company pages
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            if (items.length > columnAmount && items[columnAmount].type !== 'lassox-featured-ad' && !isPersonPage)
              items.splice(columnAmount, 0, {
                type: 'lassox-featured-ad',
                sizing: 'tall',
                id: new Date().getTime()
              })
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            return this.chunkBy(items, 2).map((c) => {
              return {
                layoutName: '2-equal',
                items: c.map((i) => ['signup-teaser', 'lassox-featured-ad'].indexOf(i.type) > -1 ? i : {
                  type: 'news-preview',
                  item: { previewType: 'basic', item: i },
                  id: i.uniqueId
                })
              }
            })
          }
        case 'home': return this.getHomeLayouts(this.items)
        case 'list': return this.getGenericHomeLayouts(this.items)
        case 'discover-overview': return this.items
      }
    }
  },
  methods: {
    chunkBy: function (items, count) {
      var i = 0
      var chunks = []
      while (items.length > i) {
          chunks.push(items.slice(i, i + count))
          i = i + count
      }
      return chunks
    },
    getHomeLayouts: function (items) {
      var layouts = []
      layouts.push({ layoutName: '2-thirds-1-third', items: [{ type: 'news-preview', item: { item: items[0], previewType: 'basic', sizing: 'tall' }, id: items[0].uniqueId }, { type: 'lassox-featured-ad', sizing: 'tall', id: new Date().getTime() }] })
      // show ebook instead
      // layouts.push({ layoutName: '3-fourths-1-fourth', items: [{ type: 'news-preview', item: { item: items[0], previewType: 'basic', sizing: 'tall' }, id: items[0].uniqueId }, { type: 'ebook', item: { sizing: 'tall' }, id: 'ebook' }] })
      layouts.push({ layoutName: 'equal-2-rows-1-row', items: [{ type: 'feed-list', item: { listType: 'latest-accounts', count: 3 }, id: 'accounts' }, { type: 'news-preview', item: { previewType: 'basic', item: items[1] }, id: items[1].uniqueId }, { type: 'person-profile', id: 'person-profile' }] })

      layouts.push({
        layoutName: '2-columns-3-fourths-1-fourth',
        items: [
          ...items.slice(2, 4).map(i => ({ type: 'news-preview', item: { previewType: 'basic', item: i, sizing: 'tall' }, id: i.uniqueId })),
          ...items.slice(4, 6).map(i => ({ type: 'news-preview', item: { previewType: 'basic', item: i, sizing: 'narrow' }, id: i.uniqueId }))
        ]
      })

      layouts.push({
        layoutName: '2-equal',
        items: [
          { type: 'feed-list', item: { listType: 'latest-news', count: 5 }, id: 'latest-news' },
          { type: 'news-preview', item: { previewType: 'basic', item: items[6], sizing: 'narrow' }, id: items[6].uniqueId }
        ]
      })

      // get generic layouts for the rest
      return layouts.concat(this.getGenericHomeLayouts(items.slice(7)))
    },
    getGenericHomeLayouts: function (feedItems) {
      var chunks = this.chunkBy(feedItems, 11)
      var layouts = []
      chunks.map(items => {
        if (items.length > 0) layouts.push({ layoutName: '3-fourths-1-fourth', items: items.slice(0, 2).map((i, index) => ({ type: 'news-preview', item: { item: i, previewType: 'basic', sizing: index ? 'narrow' : 'tall' }, id: i.uniqueId })) })
        if (items.length > 2) {
          var layout1 = { layoutName: 'equal-2-rows-1-row', items: [{ type: 'news-preview', item: { previewType: 'basic', item: items[2], noImage: true }, id: items[2].uniqueId }] }
          if (items[3]) layout1.items.push({ type: 'news-preview', item: { previewType: 'basic', item: items[3] }, id: items[3].uniqueId })
          if (items[4]) layout1.items.push({ type: 'news-preview', item: { previewType: 'basic', item: items[4], sizing: 'tall' }, id: items[4].uniqueId })
          layouts.push(layout1)
        }
        if (items[5]) layouts.push({ layoutName: '2-thirds-1-third', items: items.slice(5, 7).map((i, index) => ({ type: 'news-preview', item: { previewType: 'basic', item: i, sizing: index ? '' : 'tall' }, id: i.uniqueId })) })
        if (items[7]) layouts.push({ layoutName: '1-third-2-thirds', items: items.slice(7, 9).map((i, index) => ({ type: 'news-preview', item: { previewType: 'basic', item: i, sizing: index ? 'tall' : '' }, id: i.uniqueId })) })
        if (items[9]) layouts.push({ layoutName: '2-equal', items: items.slice(9, 11).map(i => ({ type: 'news-preview', item: { previewType: 'basic', item: i }, id: i.uniqueId })) })
      })
      return layouts
    }
  },
  components: {
    'news-preview': NewsPreview,
    'news-feed-item': NewsFeedItem,
    'news-load-footer': NewsLoadFooter
  }
}
</script>

<style lang="less">
  .news-feed-header {
    h2 {
      color: #212121;
      font-size: 25px;
      line-height: 28px;
      font-weight: 500;
    }
  }

  .match-shortest-column-grid {

    .featured-person {
      max-height: 70vh;
      margin-bottom: 30px;
      .news-feed-item-wrapper {
        height: 100%;
      }
    }

    @media (min-width: 768px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 30px;
      margin-bottom: 30px;

      .news-feed-item-wrapper {
        margin-bottom: 0px;
      }
      .news-feed-item-wrapper + .news-feed-item-wrapper {
        margin-top: 30px;
      }
      .featured-person {
        height:0;
        min-height:100%;
      }
    }
  }

  .news-feed-item-wrapper {
    margin-bottom: 30px;
  }
</style>
